import { useTranslation } from 'react-i18next';

export const useRequiredMsg = () => {
  const { t } = useTranslation('common');
  return t('form.errors.required');
};

export const useArrayMinMsg = (min: number) => {
  const { t } = useTranslation('common');
  return t('form.errors.arrayMin', { min });
};

export const useArrayMaxMsg = (max: number) => {
  const { t } = useTranslation('common');
  return t('form.errors.arrayMax', { max });
};
